import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import treeService from '../../../services/tree.service';
import { DEFAULT_NODE_WIDTH, DEFAULT_SHAPE, DEFAULT_SPACING_FACTOR } from './cy-constant';
import { clearSelection } from './cy-core';

const initialState = {
  treeData: null,
  sampleId: null,
  loading: false,
  error: null,
  focus: false,
  config: {
    space: DEFAULT_SPACING_FACTOR,
    size: DEFAULT_NODE_WIDTH,
    shape: DEFAULT_SHAPE,
  },
  currentNode: {
    id: null,
    name: null,
    img: null,
    gender: null,
    birthYear: null,
    birthMonth: null,
    birthDay: null,
    depth: null,
    isDead: null,
  },
  treeDetail: {},
  isSaving: false,
  images: [],
  imgUrl: null,
  fileName: null,
};

export const getTreeData = createAsyncThunk('tree/getList', async (payload) => {
  const response = await treeService.getTreeData(payload);
  return response;
});

export const updateTree = createAsyncThunk('tree/update', async (payload, { rejectWithValue }) => {
  try {
    // debug-console.log('tree-slice.updatetree: ');
    // // debug-console.log(payload);
    const response = treeService.updateTree(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const treeManagementSlice = createSlice({
  name: 'tree',
  initialState,
  reducers: {
    setSampleId(state, action) {
      state.sampleId = action.payload;
    },
    setImages(state, action) {
      state.images = action.payload;
    },
    setImgUrl(state, action) {
      state.imgUrl = action.payload;
    },
    setFileName(state, action) {
      state.fileName = action.payload;
    },
    setFocus(state, action) {
      state.focus = action.payload;
    },
    setCurrentNode(state, action) {
      state.currentNode = action.payload;
    },
    setTreeLoading(state, action) {
      state.currentNode = initialState.currentNode;
      state.loading = action.payload;
    },
    setTreeData(state, action) {
      if (action.payload) {
        state.treeData = action.payload;
        state.loading = false;
      }      
    },
    setTreeDataAndConfig(state, action) {
      state.treeData = action.payload.data;
      if (action.payload.config) {
        state.config = JSON.parse(action.payload.config);
      }
      state.loading = false;
    },
    setIsSaving(state, action) {
      state.isSaving = action.payload;
    },
    cleanUpState(state) {
      // state.treeData = initialState.treeData;
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.focus = initialState.focus;
      state.currentNode = initialState.currentNode;
      state.treeDetail = initialState.treeDetail;
      state.isSaving = initialState.isSaving;
      clearSelection();
    },
  },
  extraReducers: (builder) => {
    // getTreeData
    builder.addCase(getTreeData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTreeData.fulfilled, (state) => {
      state.error = null;
      // state.isSaving = false;
    });
    builder.addCase(getTreeData.rejected, (state, action) => {
      state.error = action.payload;
      // state.isSaving = false;
    });
    // update tree
    builder.addCase(updateTree.pending, (state) => {
      state.isSaving = true;
    });
    builder.addCase(updateTree.fulfilled, (state) => {
      state.error = null;
      // state.isSaving = false;
    });
    builder.addCase(updateTree.rejected, (state, action) => {
      state.error = action.payload;
      // state.isSaving = false;
    });
  },
});

export const {
  setIsSaving,
  setSampleId,
  setTreeLoading,
  setTreeData,
  setTreeDataAndConfig,
  setCurrentNode,
  setFocus,
  setImages,
  setImgUrl,
  setFileName,
  cleanUpState,
} = treeManagementSlice.actions;
export default treeManagementSlice.reducer;
